import script from "./WishesModerate.vue?vue&type=script&setup=true&lang=js"
export * from "./WishesModerate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__